import Index from './index.vue'
// import Create from './components/Create.vue'
import List from '@/modules/MasjidImage/Ad/components/List.vue'
// import Edit from './components/Edit.vue'

export default [
  {
    path: 'adImage',
    name: 'adImage',
    component: Index,
    title: 'adImage',
    redirect: { name: 'adImage-list' },
    children: [
      {
        path: 'list',
        name: 'adImage-list',
        component: List,
      },
      
    ],
  },
]
